import { SHOULD_SKIP_AUTH_DEV } from "@core-shop/utils";

export function getAuthHeaderValue(token?: string) {
  return SHOULD_SKIP_AUTH_DEV ? `Bearer ${process.env.ACCESS_TOKEN ?? ""}` : decodeURIComponent(token ?? "");
}
